// import p5 from 'p5';
import { createHash } from 'crypto';

// a method with a single letter input that return true if is a char and fals if number
// export const isChar = (a: string | number): boolean => {
//     return isNaN(a * 1);
// }

export const hexToRGBA = (hex: string, alpha: string): string => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export const generateDiagonalSquareCSS = (elementId) => {

    console.log("generateDiagonalSquareCSS");
    const el = document.getElementById(elementId);
    const sideLength = el.offsetWidth / Math.sqrt(2);
    const sideLengthHalf = el.offsetWidth / 2 / Math.sqrt(2);
    const left = (el.offsetWidth - sideLength) / 2;
    const topHalf = (el.offsetHeight - sideLengthHalf) / 2;
    const leftHalf = (el.offsetWidth - sideLengthHalf) / 2;
    const css = `
            .diagonal {
                width: ${sideLength}px;
                height: ${sideLength}px;
                top: ${top}px;
                left: ${left}px;
            }
                        
            .diagonalHalf {
                width: ${sideLengthHalf}px;
                height: ${sideLengthHalf}px;
                top: ${topHalf}px;
                left: ${leftHalf}px;
            }
            `;
    const styleElement = document.querySelector('style');
    styleElement.innerHTML += css;
}

export const generateCSSClasses = (colorJson: any) => {
    let cssString = '';
    let css = '';
    for (const key in colorJson) {

        const color = colorJson[key];
        const rgbaColor = hexToRGBA(color, '1');
        const classNameBase = key.replace('_', '');
        css += `
            .bg${classNameBase} {
                background-color: ${rgbaColor};
            }
            .bg${classNameBase}Gradient {
                background-image: linear-gradient(${rgbaColor}, rgba(0, 0, 0, 0));
            }
             .bg${classNameBase}GradientToBottom {
                background-image: linear-gradient(rgba(0, 0, 0, 0), ${rgbaColor});
            }
            .bg${classNameBase}GradientToTheRight {
                background-image: linear-gradient(to right, ${rgbaColor}, rgba(0, 0, 0, 0));
            }
            .bg${classNameBase}GradientToTheLeft {
                background-image: linear-gradient(to left, ${rgbaColor}, rgba(0, 0, 0, 0));
            }
            .${classNameBase} {
                box-shadow: 0 0 5vmin 0.5vmin ${rgbaColor}, inset 0 0 2vmin 1vmin ${rgbaColor};
            }
            .inner${classNameBase} {
                box-shadow: inset 0 0 1.5vmin 0.5vmin ${rgbaColor};
            }
            .outer${classNameBase} {
                box-shadow: 0 0 2vmin 1vmin ${rgbaColor};
            }
        `;

    }

    // add css to cssstring
    cssString += css;
    const styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = cssString;
    document.head.appendChild(styleElement);
}



export const getNumberOfAttributes = (obj: object): number => {
    return Object.keys(obj).length;
}

export const removePrefix = (input: string, prefix: string): string => {
    const regex = new RegExp(`^${prefix}`);
    return input.replace(regex, "");
}

export const generateLongStringFromHashSHA = (hash: string, length: number): string => {
    let result = '';
    let input = hash;


    while (result.length < length) {
        const sha256 = createHash('sha256');
        sha256.update(input);
        const digest = sha256.digest('hex');
        result += digest;  // Hex-Werte als Zeichenfolge hinzufügen
        input = digest;    // Nächstes Input ist das Ergebnis des letzten Hashes
    }

    return result.slice(0, length);  // Auf die gewünschte Länge zuschneiden
}

export const getRandomDirection = (): number => {
    const directions = [1, 2, 3, 4] as const;
    const randomIndex = Math.floor(Math.random() * directions.length);
    return directions[randomIndex];
}

const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

// Funktion, um Hashes in eine Zeichenfolge aus dem benutzerdefinierten Zeichenset zu konvertieren
export const hashToCharset = (hash: string, length: number): string => {
    let result = '';
    let input = hash;
    while (result.length < length) {
        const sha256 = createHash('sha256');
        sha256.update(input);
        const digest = sha256.digest(); // Digest als Buffer

        // Jeden Byte-Wert in einen Index im Charset mappen
        for (let byte of digest) {
            result += charset[byte % charset.length]; // Mapped den Byte-Wert auf ein Zeichen
        }

        input = digest.toString('hex'); // Nächstes Input ist der Hash-Wert als Hex-String
    }

    return result.slice(0, length); // Auf die gewünschte Länge zuschneiden
}

export const hashToNumbers = (hash: string, length: number): number[] => {
    let result: number[] = [];
    let input = hash;

    while (result.length < length) {
        const sha256 = createHash('sha256');
        sha256.update(input);
        const digest = sha256.digest(); // Digest als Buffer

        // Jeden Byte-Wert in einen Index im Charset mappen
        for (let byte of digest) {
            result.push(byte);
        }

        input = digest.toString('hex'); // Nächstes Input ist der Hash-Wert als Hex-String
    }

    return result.slice(0, length); // Auf die gewünschte Länge zuschneiden
}

export const generateRandom = (x: number, y: number, p: p5): number => {
    const n = Math.floor(p.random(x, y));
    // console.log(n);
    return n;
}

// export const getRandomColor = (p: p5) => {
//     return p.color(generateRandom(0, 255, p), generateRandom(0, 255, p), generateRandom(0, 255, p));
// }

// export const getColorByName = (name: string): p5.Color => {
//     const p = window.globalP5;
//     switch (name) {
//         case 'white':
//             return p.color(255, 255, 255);
//         case 'black':
//             return p.color(0, 0, 0);
//         case 'blue':
//             return p.color(0, 100, 200);
//         case 'grey':
//             return p.color(128, 128, 128);
//         case 'pink':
//             return p.color(255, 192, 203);
//         case 'lightblue':
//             return p.color(173, 216, 230);
//         case 'darkblue':
//             return p.color(0, 0, 139);
//         case 'red':
//             return p.color(255, 0, 0);
//         default:
//             return p.color(255, 255, 255);
//     }
// }
